const messages = [
  "Preparando as coisas…",
  "Organizando seu espaço…",
  "Deixando tudo pronto…",
  "Arrumando os últimos detalhes…",
  "Preparando seu próximo passo…",
  "Quase tudo pronto por aqui…",
] as const;
const key = "edu.loading-message";
let previousInMemory: number | null = null;

export function chooseLoadingMessage() {
  let previous = previousInMemory;
  try {
    const stored = sessionStorage.getItem(key);
    previous = stored === null ? null : Number(stored);
  } catch {
    /* Funciona também com storage bloqueado. */
  }
  const index =
    previous !== null && Number.isInteger(previous) && previous >= 0 && previous < messages.length
      ? (previous + 1 + Math.floor(Math.random() * (messages.length - 1))) % messages.length
      : 0;
  return { index, text: messages[index] };
}

export function rememberLoadingMessage(index: number) {
  previousInMemory = index;
  try {
    sessionStorage.setItem(key, String(index));
  } catch {
    /* cache opcional */
  }
}
